import { formatPhoneNumber } from "../utils/format-utils";
import Language from "./Language";
import Discipline from "./Discipline";
import DisciplineSubCode from "./DisciplineSubCode";

export default class Provider {
  providerId?: number | null;
  legacyProviderId?: string | null;
  title?: string | null;
  firstName?: string | null;
  middleInitial?: string | null;
  lastName?: string | null;
  gender?: string | null;
  streetAddress?: string | null;
  streetAddressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  homePhone?: string | null;
  mobilePhone?: string | null;
  workPhone?: string | null;
  preferredPhone?: string | null;
  emailAddress?: string | null;
  workEmailAddress?: string | null;
  certification?: string | null;
  license?: string | null;
  npi?: string | null;
  supervisorId?: number | null;
  disciplineSubCodes?: DisciplineSubCode[] | null;
  languages?: Language[] | null;
  disciplines?: Discipline[] | null;
  isActive?: boolean | null;
  isBlocked?: boolean | null;

  public constructor(params: Provider = {} as Provider) {
    let {
      providerId = 0,
      legacyProviderId = null,
      title = null,
      firstName = null,
      middleInitial = null,
      lastName = null,
      gender = null,
      streetAddress = null,
      streetAddressLine2 = null,
      city = null,
      state = null,
      zipCode = null,
      homePhone = null,
      mobilePhone = null,
      workPhone = null,
      preferredPhone = null,
      emailAddress = null,
      workEmailAddress = null,
      certification = null,
      license = null,
      npi = null,
      supervisorId = null,
      disciplineSubCodes = null,
      languages = null,
      disciplines = null,
      isActive = true,
      isBlocked = false,
    } = params;
    this.providerId = providerId;
    this.legacyProviderId = legacyProviderId;
    this.title = title;
    this.firstName = firstName;
    this.middleInitial = middleInitial;
    this.lastName = lastName;
    this.gender = gender;
    this.streetAddress = streetAddress;
    this.streetAddressLine2 = streetAddressLine2;
    this.city = city;
    this.state = state;
    this.zipCode = zipCode;
    this.homePhone = homePhone && formatPhoneNumber(homePhone);
    this.mobilePhone = mobilePhone && formatPhoneNumber(mobilePhone);
    this.workPhone = workPhone && formatPhoneNumber(workPhone);
    this.preferredPhone = preferredPhone;
    this.emailAddress = emailAddress;
    this.workEmailAddress = workEmailAddress;
    this.certification = certification;
    this.license = license;
    this.npi = npi;
    this.supervisorId = supervisorId;
    this.disciplineSubCodes =
      disciplineSubCodes &&
      disciplineSubCodes.map((item) => new DisciplineSubCode(item));
    this.languages = languages && languages.map((item) => new Language(item));
    this.disciplines =
      disciplines && disciplines.map((item) => new Discipline(item));
    this.isActive = isActive;
    this.isBlocked = isBlocked;
  }
}
